import { useMemo, type FC } from 'react';

import useFlowListData from '../api/queries/useFlowListData.js';
import ApproversTable from '../features/ApproversTable/ApproversTable.jsx';
import { mapFlowItemLiteIntoApproverTableItem } from '../utils/transformers.js';
import EmptyPage from './EmptyPage.jsx';
import DeleteFlowModal from './modals/DeleteFlowModal.jsx';
import DisableFlowModal from './modals/DisableFlowModal.jsx';
import TableSkeleton from './skeletons/TableSkeleton.jsx';

const ApprovalContainer: FC = () => {
  const { data, isPending, isError } = useFlowListData();

  const rowData = useMemo(() => {
    if (!data?.length) {
      return [];
    }

    return data.map(mapFlowItemLiteIntoApproverTableItem);
  }, [data]);

  if (isPending || isError) {
    return <TableSkeleton />;
  }

  if (!data.length) {
    return <EmptyPage />;
  }

  return (
    <>
      <ApproversTable rowData={rowData} />
      <DisableFlowModal />
      <DeleteFlowModal />
    </>
  );
};

export default ApprovalContainer;
